<template>
	<DefaultTemplate>
		<FormEdit/>
	</DefaultTemplate>
</template>
<script>
import FormEdit from '@/components/form/FormEdit'
import  DefaultTemplate from '../template/DefaultTemplate'
export default {
    components:{
        FormEdit,
        DefaultTemplate
    }
};
</script>
<style scoped>
	
</style>